import { AddressKind } from '@lojinha/palantir'

export type Address = {
  id: string
  kind: AddressKind
  street: string
  number?: string | null
  complement?: string | null
  zipCode: string
  neighborhood: string
  city: string
  lastUsedAt?: string
  state: string
  country: string
  coordinates: {
    latitude: number
    longitude: number
  }
  nearestDistributionCenter?: {
    id: string
  }
  deliveryCost?: number
}

export enum PlaceKind {
  House = 'HOME',
  Building = 'BUILDING',
}

export type AddressData = {
  zipCode: string
  street: string
  number: string
  complement: string
  neighborhood: string
  building?: string
  placeKind?: PlaceKind
  city: string
  state: string
  country: string
  coordinates: {
    latitude: number
    longitude: number
  }
}

export type UseSaveAddress = {
  defaultValues: Partial<AddressData>
  onSubmit: (address: Address) => Promise<void>
  onCancel?: () => void
  isLoadingSaveDeliveryAddress: boolean
}

export type UseSaveAddressOptions = {
  onCreate: (address: Address, isNewAddress: boolean) => Promise<void>
}
